/* eslint-disable no-useless-concat */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

//how do i tell if the seller is onilne or offline?

// suggest improvements for this component
// give me the entire code to copy


// i want to see if the seller has a socket connection
// give me the relevant code with instructions


import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';

import { AiOutlineMessage } from 'react-icons/ai';
import { IoSend } from 'react-icons/io5';
import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';
import { BsArrowsAngleExpand, BsArrowsAngleContract, BsCheck2, BsCheck2All } from 'react-icons/bs';

import { add_friend, messageClear, send_message_to_seller, updateMessage } from '../../store/reducers/chatReducer';
import GetSellerConfig from '../GetSellerConfig';

import toast from 'react-hot-toast';
import Moment from 'moment/moment';
import config from '../../config';
import io from 'socket.io-client';

const socket = io(config.STR_BACKEND_URL);

const Chat = () => {
    const sellerFrontendURL = config.STR_FRONTEND_URL;

    const { userInfo } = useSelector(state => state.auth);
    const { fb_messages, currentFd, my_friends, successMessage } = useSelector(state => state.chat);
    const customerName = userInfo?.name;
    const { seller } = useSelector(state => state.seller);
    //const sellerChatOnline = seller?.isVisibleSiteChatOnline
    const [seenBySellerIds, setSeenBySellerIds] = useState(new Set());

    const {
        sellerId, 
        sellerColorDark, sellerColorMedium, sellerColorLight,
        // sellerPrimaryColor1, sellerSecondaryColor1, sellerColorSuffixDark, sellerColorSuffixMedium, 
        // sellerColorSuffixLight, 
        //sellerComponentBackgroundColor,
        sellerShopName, sellerSellerImage, 
        sellerChatOfflineMessage, sellerBoolShowSiteChatOnline
    } = GetSellerConfig();

    const scrollRef = useRef();
    const textareaRef = useRef();
    const dispatch = useDispatch();

    let { chatTopic } = useParams();
    if (chatTopic === undefined) {
        chatTopic = '';
    } else {
        chatTopic = chatTopic !== '' ? 'I Have A Question About ' + chatTopic : '';
    }

    const [text, setText] = useState(chatTopic);
    const [receiverMessage, setReceiverMessage] = useState('');
    const [activeSeller, setActiveSeller] = useState([]);
    const [show, setShow] = useState(false);

    const [sellerTyping, setSellerTyping] = useState(false)
    const typingTimeoutRef = useRef(null)
    const sellerTypingTimeoutRef = useRef(null)

    // NEW: controls whether the message textarea is expanded or in its compact state
    const [isExpanded, setIsExpanded] = useState(false);

    // NEW: toggles the textarea between compact and expanded states
    const toggleExpand = () => {
        setIsExpanded(prev => !prev);
    };

    const handleTextChange = (e) => {
        const value = e.target.value
        setText(value)
        if (!sellerId) return

        socket.emit('customer_typing', { senderId: userInfo.id, receiverId: sellerId, isTyping: true })

        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
            typingTimeoutRef.current = setTimeout(() => {
                socket.emit('customer_typing', { senderId: userInfo.id, receiverId: sellerId, isTyping: false })
        }, 2500)
    }

    useEffect(() => {
        dispatch(add_friend({
            sellerId: sellerId || '',
            userId: userInfo.id
        }));
    }, [sellerId]);

    const send_message_to_seller_local = () => {
        const trimmed = text.trim();
        if (!trimmed) return;
        dispatch(send_message_to_seller({
            userId: userInfo.id,
            text: trimmed,
            sellerId,
            name: userInfo.name
        }));
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current)
            socket.emit('customer_typing', { senderId: userInfo.id, receiverId: sellerId, isTyping: false })
        setText('');
        socket.emit('add_user', userInfo.id, userInfo);
    };

    useEffect(() => {
        const handleSellerTyping = (data) => {
            if (data.senderId === sellerId && data.receiverId === userInfo.id) {
                setSellerTyping(data.isTyping)
                if (sellerTypingTimeoutRef.current) clearTimeout(sellerTypingTimeoutRef.current)
                if (data.isTyping) {
                    sellerTypingTimeoutRef.current = setTimeout(() => setSellerTyping(false), 3000)
                }
            }
        }
        socket.on('seller_typing', handleSellerTyping)
        return () => {
            socket.off('seller_typing', handleSellerTyping)
            setSellerTyping(false)
        }
    },[sellerId, userInfo.id])

    useEffect(() => {
        if (!currentFd?.fdId || fb_messages.length === 0) return
        const unseenSellerMsgIds = fb_messages
            .filter(m => currentFd?.fdId !== m.receiverId && !m.seen) // i.e. message came from the seller
            .map(m => m._id)

        if (unseenSellerMsgIds.length > 0) {
            socket.emit('customer_read_messages', {
                customerId: userInfo.id,
                sellerId,
                messageIds: unseenSellerMsgIds
            })
        }
    },[currentFd, fb_messages])

    useEffect(() => {
        const handleSeenBySeller = (data) => {
            if (data.customerId === userInfo.id) {
                setSeenBySellerIds(prev => {
                    const updated = new Set(prev)
                    data.messageIds.forEach(id => updated.add(id))
                    return updated
                })
            }
        }
        socket.on('messages_seen_by_seller', handleSeenBySeller)
        return () => socket.off('messages_seen_by_seller', handleSeenBySeller)
    },[userInfo.id])

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            send_message_to_seller_local();
        }
    };

    useEffect(() => {
        socket.on('seller_message', msg => setReceiverMessage(msg));
        socket.on('activeSeller', sellers => setActiveSeller(sellers));
    }, []);

    useEffect(() => {
        if (successMessage) {
            socket.emit('send_customer_message', fb_messages[fb_messages.length - 1]);
            dispatch(messageClear());
        }
    }, [successMessage]);

    useEffect(() => {
        if (receiverMessage) {
            if (sellerId === receiverMessage.senderId && userInfo.id === receiverMessage.receiverId) {
                toast.success(`${receiverMessage.senderName} \nSent A Message`);
                dispatch(updateMessage(receiverMessage));
            } else {
                toast.success(`${receiverMessage.senderName} \nSent A Message`);
                dispatch(messageClear());
            }
        }
    }, [receiverMessage]); 
    // 
    useEffect(() => {
        scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, [fb_messages]);

    //const isChatEnabled = sellerBoolShowSiteChatOnline;
    //const canSend = isChatEnabled && text.trim().length > 0;
    //const isSellerSocketConnected1 = activeSeller.some(c => c.sellerId === sellerId)
    let strSellerSocketConnectedSuffix = '' //sellerBoolShowSiteChatOnline ? 'Online' : 'Offline';
    //strSellerSocketConnectedSuffix += sellerBoolShowSiteChatOnline ? '' : ' Off1';
    //strSellerSocketConnectedSuffix += activeSeller.some(c => c.sellerId === sellerId) ? '' : ' Off2'; 
    //const isSellerSocketConnected = (activeSeller.some(c => c.sellerId === sellerId) && sellerBoolShowSiteChatOnline)
    const isSellerSocketConnected = sellerBoolShowSiteChatOnline
    
    const canSend = isSellerSocketConnected && text.trim().length > 0;

    // console.log('isSellerSocketConnected', isSellerSocketConnected,'\nsellerBoolShowSiteChatOnline', sellerBoolShowSiteChatOnline)
    // console.log('isSellerSocketConnected1', isSellerSocketConnected1)


    //&& sellerBoolShowSiteChatOnline
    //sellerBoolShowSiteChatOnline

    return (
        <div className='bg-white rounded-2xl'>
            <div
                className='p-4 border rounded-2xl'
                style={{ 
                    backgroundColor: sellerColorLight, 
                    color: sellerColorDark, 
                    borderColor: sellerColorDark 
                }}>
                {/* Header 
                    flex justify-between items-center
                    */}
                <div className="flex items-center gap-2 mb-1 pb-0">
                    <div>
                        <IoChatbubbleEllipsesOutline size={44} style={{ color: sellerColorDark }} />
                    </div>
                    <div>
                        <div
                            className="text-2xl font-bold tracking-tight leading-none  
                            border-none border-black"
                            style={{ color: sellerColorDark }}>
                            Chat With {sellerShopName}
                            <span
                                className={`text-xs ml-2 px-2  py-0.5 rounded-lg
                                    ${isSellerSocketConnected
                                        ? 'bg-green-100 text-green-500 border-2 border-green-500'
                                        : 'bg-red-100 text-red-500 border-2 border-red-500'
                                    }`}>                                
                                { isSellerSocketConnected ? '● Online' : '○ Offline ' + strSellerSocketConnectedSuffix }
                            </span>
                        </div>
                        <div className="text-md mt-0.5" style={{ color: sellerColorMedium }}>
                            We really like staying in touch
                        </div>
                    </div>
                </div>
                <div className='w-full flex gap-3'>
                    {/* Friends sidebar 
                    className={`w-[200px] flex-shrink-0 border rounded-lg overflow-hidden hidden md-lg:block
                            ${show ? 'block' : 'hidden'}`}
                        changed md-lg:block to md-lg:hidden
                    */}
                    <div
                        className={`w-[200px] flex-shrink-0 border rounded-lg overflow-hidden hidden md-lg:hidden
                            ${show ? 'block' : 'hidden'}`}
                        style={{ borderColor: sellerColorDark }}>
                        <div
                            className='flex items-center gap-2 px-3 h-[46px] font-semibold text-sm border-b'
                            style={{ 
                                borderColor: sellerColorDark, 
                                color: sellerColorDark
                            }}>
                            <AiOutlineMessage />
                            <span>Messages</span>
                        </div>
                        <div className='flex flex-col py-1 overflow-y-auto max-h-[200px]'>
                            {my_friends.map((f, i) => (
                                <Link
                                    to={`/customerDashboard/chat/${f.fdId}`}
                                    key={i}
                                    className='flex items-center gap-2 px-3 py-2 hover:bg-black/5 transition-colors'>
                                    <div className='w-[28px] h-[28px] rounded-full relative flex-shrink-0'>
                                        {activeSeller.some(c => c.sellerId === f.fdId) && (
                                            <div className='w-[9px] h-[9px] rounded-full bg-green-500 border-2 border-white absolute right-0 bottom-0 z-10' />
                                        )}
                                        <img className='w-full h-full rounded-full object-cover' src={sellerSellerImage} alt={sellerShopName} />
                                    </div>
                                    <span className='text-sm font-medium truncate' style={{ color: sellerColorDark }}>
                                        {sellerShopName}
                                    </span>
                                </Link>
                            ))}
                        </div>
                    </div>

                    {/* Main chat area */}
                    <div className='flex-1 min-w-0'>
                        {currentFd ? (
                            <div className='flex flex-col gap-2'>
                                {/* Message list */}
                                {/* CHANGED: height shrinks a bit when the textarea is expanded */}
                                <div
                                    className={`w-full border-2 p-3 overflow-y-auto flex flex-col gap-3 transition-all
                                        ${isExpanded ? 'h-[200px]' : 'h-[330px]'}`}
                                    style={{
                                        backgroundColor: sellerColorLight,
                                        borderColor: sellerColorDark,
                                        borderRadius: "18px 0px 0px 18px",
                                    }}>
                                    {fb_messages.map((m, i) => {
                                        const isSellerMsg = currentFd?.fdId !== m.receiverId;
                                        return (
                                            <div
                                                ref={scrollRef}
                                                key={i}
                                                className={`flex gap-2 items-end ${isSellerMsg ? 'justify-start' : 'justify-end'}`}>
                                                {isSellerMsg && (
                                                    <div className='flex flex-col items-center flex-shrink-0'>
                                                        <img
                                                            className='w-[32px] h-[32px] rounded-full object-cover border-2'
                                                            src={sellerSellerImage}
                                                            alt={sellerShopName}
                                                            style={{ borderColor: sellerColorDark }}
                                                        />
                                                        <span className='text-[9px] font-semibold mt-0.5' 
                                                            style={{ color: sellerColorDark }}>
                                                            {sellerShopName.substring(0, 8)}
                                                        </span>
                                                    </div>
                                                )}
                                                {/*  bg-cyan-500 bg-purple-500 */}
                                                <div
                                                    className={`px-3 py-2 rounded-2xl max-w-[75%] text-white text-sm leading-snug shadow-sm 
                                                        border-2 border-red-700
                                                        ${isSellerMsg ? 'rounded-bl-sm' : 'rounded-br-sm'
                                                        }`}
                                                    style={{
                                                        // backgroundColor: isSellerMsg ? sellerPrimaryColor1 : sellerPrimaryColor1 + sellerColorSuffixMedium,
                                                        // color: isSellerMsg ? 'white' : 'black',
                                                        // borderColor: isSellerMsg ? sellerPrimaryColor1 : 'transparent'

                                                        backgroundColor: isSellerMsg ? sellerColorDark : 'white',
                                                        color: isSellerMsg ? 'white' : sellerColorDark,
                                                        borderColor: isSellerMsg ? 'transparent' : sellerColorDark 
                                                    }}>
                                                    <p className='break-words text-[13px] font-semibold'>{m.message}</p>
                                                    <p className='text-[11px] mt-0.5 opacity-70 flex items-center justify-end gap-1'>
                                                        <span>{Moment(m.updatedAt).format('M/DD/YY h:mm a')}</span>
                                                        {!isSellerMsg && (
                                                            seenBySellerIds.has(m._id)
                                                                ? <BsCheck2All className='text-[13px]' style={{ color: sellerColorDark }} title='Seen' />
                                                                : <BsCheck2 className='text-[13px] opacity-60' title='Sent' />
                                                        )}
                                                    </p>
                                                    {
                                                    // <p className='text-[11px] mt-0.5 opacity-70 text-right'>
                                                    //     {Moment(m.updatedAt).format('M/DD/YY h:mm a')}
                                                    // </p>
                                                    }
                                                    

                                                </div>

                                                {!isSellerMsg && (
                                                    <div className='flex flex-col items-center flex-shrink-0'>
                                                        <img
                                                            className='w-[32px] h-[32px] rounded-full object-cover border-2'
                                                            src={`${sellerFrontendURL}/images/user.png`}
                                                            alt={customerName}
                                                            style={{ borderColor: sellerColorDark }}
                                                        />
                                                        <span className='text-[10px] font-semibold mt-0.5' 
                                                            style={{ color: sellerColorDark }}>
                                                            {customerName?.substring(0, 8)}
                                                        </span>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                    <div className={` ${fb_messages.length > 0 ? 'hidden' : ''}  
                                        w-full flex justify-center items-center text-[26px] font-semibold gap-2 mt-24`}
                                        style={{ color: sellerColorMedium }}>
                                        <IoChatbubbleEllipsesOutline size={42}  />
                                        Let's Start A Conversation
                                    </div>
                                </div>
                                {sellerTyping && (
                                    <div className='flex items-center gap-1 px-0.5 text-[12px]' 
                                        style={{ color: sellerColorDark }}>
                                        <span>{sellerShopName} Typing</span>
                                        <span className='animate-pulse'></span>
                                        <span className="inline-flex gap-1">
                                            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:-0.3s]"></span>
                                            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce [animation-delay:-0.15s]"></span>
                                            <span className="w-1.5 h-1.5 bg-current rounded-full animate-bounce"></span>
                                        </span>
                                    </div>
                                )}
                                {/* Input bar */}
                                {isSellerSocketConnected && (
                                    <div
                                        className='flex items-start mt-0 pl-0 border-2 rounded-md'
                                        style={{ 
                                            //borderColor: sellerColorDark, 
                                            borderColor: canSend ? sellerColorDark : sellerColorMedium,
                                            backgroundColor: sellerColorLight
                                        }}>
                                        {/* CHANGED: fixed height toggled by isExpanded instead of auto-growing with content 
                                            onChange={e => setText(e.target.value)}
                                        */}
                                        <textarea
                                            ref={textareaRef}
                                            value={text}
                                            onChange={handleTextChange}
                                            onKeyDown={handleKeyDown}
                                            placeholder='Type a message… (Enter to send, Shift+Enter for new line)'
                                            className={`flex-1 resize-none outline-none bg-transparent text-[16px] leading-snug 
                                            py-0.5 px-2 overflow-y-auto border-none border-black transition-all
                                            ${isExpanded ? 'h-[160px]' : 'h-[26px]'}`}
                                            style={{ color: sellerColorDark }}
                                        />

                                        {/* NEW: Send button and toggle button stacked in a column, 
                                            combined height (26+26+4=56px) matches the collapsed textarea height */}
                                        <div className='flex  justify-between gap-1 m-0'>
                                            <button
                                                onClick={send_message_to_seller_local} aria-label='Send message' disabled={!canSend}
                                                className='flex-shrink-0 w-[42px] h-[26px] rounded-md flex items-center 
                                                    justify-center text-white transition-opacity'
                                                style={{
                                                    backgroundColor: canSend ? sellerColorDark : sellerColorMedium,
                                                    cursor: canSend ? 'pointer' : 'not-allowed'
                                                }}>
                                                <IoSend className='text-[18px] sm:text-[26px]' />
                                            </button>
                                            <button
                                                type='button'
                                                onClick={toggleExpand}
                                                aria-label={isExpanded ? 'Shrink message box' : 'Expand message box'}
                                                title={isExpanded ? 'Shrink message box' : 'Expand message box'}
                                                className='flex-shrink-0 w-[42px] h-[26px] rounded-md flex items-center 
                                                    justify-center text-white transition-opacity'
                                                style={{ backgroundColor: sellerColorDark }}>
                                                {
                                                    isExpanded 
                                                        ? <BsArrowsAngleContract className='text-[14px]' />
                                                        : <BsArrowsAngleExpand className='text-[14px]' />
                                                }
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className='w-full py-10 flex flex-col justify-center items-center gap-3'>
                                <IoChatbubbleEllipsesOutline className='text-5xl' style={{ color: sellerColorMedium }} />
                                <span className='text-base font-semibold' style={{ color: sellerColorMedium }}>
                                    One moment please…
                                </span>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Chat;





// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom';

// import { AiOutlineMessage } from 'react-icons/ai';
// import { IoSend } from 'react-icons/io5';
// import { IoChatbubbleEllipsesOutline } from 'react-icons/io5';

// import { add_friend, messageClear, send_message_to_seller, updateMessage } from '../../store/reducers/chatReducer';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import Moment from 'moment/moment';
// import config from '../../config';
// import io from 'socket.io-client';

// const socket = io(config.STR_BACKEND_URL);

// const Chat = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL;

//     const { userInfo } = useSelector(state => state.auth);
//     const { fb_messages, currentFd, my_friends, successMessage } = useSelector(state => state.chat);
//     const customerName = userInfo?.name;
//     const { seller } = useSelector(state => state.seller);
//     //const sellerChatOnline = seller?.isVisibleSiteChatOnline

//     const {
//         sellerId, 
//         sellerColorDark, sellerColorMedium, sellerColorLight,
//         // sellerPrimaryColor1, sellerSecondaryColor1, sellerColorSuffixDark, sellerColorSuffixMedium, 
//         // sellerColorSuffixLight, 
//         //sellerComponentBackgroundColor,
//         sellerShopName, sellerSellerImage, 
//         sellerChatOfflineMessage, sellerBoolShowSiteChatOnline
//     } = GetSellerConfig();

//     const scrollRef = useRef();
//     const textareaRef = useRef();
//     const dispatch = useDispatch();

//     let { chatTopic } = useParams();
//     if (chatTopic === undefined) {
//         chatTopic = '';
//     } else {
//         chatTopic = chatTopic !== '' ? 'I Have A Question About ' + chatTopic : '';
//     }

//     const [text, setText] = useState(chatTopic);
//     const [receiverMessage, setReceiverMessage] = useState('');
//     const [activeSeller, setActiveSeller] = useState([]);
//     const [show, setShow] = useState(false);

//     // Auto-resize textarea
//     useEffect(() => {
//         const el = textareaRef.current;
//         if (!el) return;
//         el.style.height = 'auto';
//         el.style.height = Math.min(el.scrollHeight, 120) + 'px';
//     }, [text]);

//     useEffect(() => {
//         dispatch(add_friend({
//             sellerId: sellerId || '',
//             userId: userInfo.id
//         }));
//     }, [sellerId]);

//     const send_message_to_seller_local = () => {
//         const trimmed = text.trim();
//         if (!trimmed) return;
//         dispatch(send_message_to_seller({
//             userId: userInfo.id,
//             text: trimmed,
//             sellerId,
//             name: userInfo.name
//         }));
//         setText('');
//         socket.emit('add_user', userInfo.id, userInfo);
//     };

//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter' && !event.shiftKey) {
//             event.preventDefault();
//             send_message_to_seller_local();
//         }
//     };

//     useEffect(() => {
//         socket.on('seller_message', msg => setReceiverMessage(msg));
//         socket.on('activeSeller', sellers => setActiveSeller(sellers));
//     }, []);

//     useEffect(() => {
//         if (successMessage) {
//             socket.emit('send_customer_message', fb_messages[fb_messages.length - 1]);
//             dispatch(messageClear());
//         }
//     }, [successMessage]);

//     useEffect(() => {
//         if (receiverMessage) {
//             if (sellerId === receiverMessage.senderId && userInfo.id === receiverMessage.receiverId) {
//                 toast.success(`${receiverMessage.senderName} \nSent A Message`);
//                 dispatch(updateMessage(receiverMessage));
//             } else {
//                 toast.success(`${receiverMessage.senderName} \nSent A Message`);
//                 dispatch(messageClear());
//             }
//         }
//     }, [receiverMessage]); 
//     // 
//     useEffect(() => {
//         scrollRef.current?.scrollIntoView({ behavior: 'smooth' });
//     }, [fb_messages]);

//     //const isChatEnabled = sellerBoolShowSiteChatOnline;
//     //const canSend = isChatEnabled && text.trim().length > 0;
//     //const isSellerSocketConnected1 = activeSeller.some(c => c.sellerId === sellerId)
//     let strSellerSocketConnectedSuffix = '' //sellerBoolShowSiteChatOnline ? 'Online' : 'Offline';
//     //strSellerSocketConnectedSuffix += sellerBoolShowSiteChatOnline ? '' : ' Off1';
//     //strSellerSocketConnectedSuffix += activeSeller.some(c => c.sellerId === sellerId) ? '' : ' Off2'; 
//     //const isSellerSocketConnected = (activeSeller.some(c => c.sellerId === sellerId) && sellerBoolShowSiteChatOnline)
//     const isSellerSocketConnected = sellerBoolShowSiteChatOnline
    
//     const canSend = isSellerSocketConnected && text.trim().length > 0;

//     // console.log('isSellerSocketConnected', isSellerSocketConnected,'\nsellerBoolShowSiteChatOnline', sellerBoolShowSiteChatOnline)
//     // console.log('isSellerSocketConnected1', isSellerSocketConnected1)


//     //&& sellerBoolShowSiteChatOnline
//     //sellerBoolShowSiteChatOnline

//     return (
//         <div className='bg-white rounded-2xl'>
//             <div
//                 className='p-4 border rounded-2xl'
//                 style={{ 
//                     backgroundColor: sellerColorLight, 
//                     color: sellerColorDark, 
//                     borderColor: sellerColorDark 
//                 }}>
//                 {/* Header 
//                     flex justify-between items-center
//                     */}
//                 <div className="flex items-center gap-2 mb-1 pb-0">
//                     <div>
//                         <IoChatbubbleEllipsesOutline size={44} style={{ color: sellerColorDark }} />
//                     </div>
//                     <div>
//                         <div
//                             className="text-2xl font-bold tracking-tight leading-none  
//                             border-none border-black"
//                             style={{ color: sellerColorDark }}>
//                             Chat With {sellerShopName}
//                             <span
//                                 className={`text-xs ml-2 px-2  py-0.5 rounded-lg
//                                     ${isSellerSocketConnected
//                                         ? 'bg-green-100 text-green-500 border-2 border-green-500'
//                                         : 'bg-red-100 text-red-500 border-2 border-red-500'
//                                     }`}>                                
//                                 { isSellerSocketConnected ? '● Online' : '○ Offline ' + strSellerSocketConnectedSuffix }
//                             </span>
//                         </div>
//                         <div className="text-md mt-0.5" style={{ color: sellerColorMedium }}>
//                             We really like staying in touch
//                         </div>
//                     </div>
//                 </div>
//                 <div className='w-full flex gap-3'>
//                     {/* Friends sidebar 
//                     className={`w-[200px] flex-shrink-0 border rounded-lg overflow-hidden hidden md-lg:block
//                             ${show ? 'block' : 'hidden'}`}
//                         changed md-lg:block to md-lg:hidden
//                     */}
//                     <div
//                         className={`w-[200px] flex-shrink-0 border rounded-lg overflow-hidden hidden md-lg:hidden
//                             ${show ? 'block' : 'hidden'}`}
//                         style={{ borderColor: sellerColorDark }}>
//                         <div
//                             className='flex items-center gap-2 px-3 h-[46px] font-semibold text-sm border-b'
//                             style={{ 
//                                 borderColor: sellerColorDark, 
//                                 color: sellerColorDark
//                             }}>
//                             <AiOutlineMessage />
//                             <span>Messages</span>
//                         </div>
//                         <div className='flex flex-col py-1 overflow-y-auto max-h-[200px]'>
//                             {my_friends.map((f, i) => (
//                                 <Link
//                                     to={`/customerDashboard/chat/${f.fdId}`}
//                                     key={i}
//                                     className='flex items-center gap-2 px-3 py-2 hover:bg-black/5 transition-colors'>
//                                     <div className='w-[28px] h-[28px] rounded-full relative flex-shrink-0'>
//                                         {activeSeller.some(c => c.sellerId === f.fdId) && (
//                                             <div className='w-[9px] h-[9px] rounded-full bg-green-500 border-2 border-white absolute right-0 bottom-0 z-10' />
//                                         )}
//                                         <img className='w-full h-full rounded-full object-cover' src={sellerSellerImage} alt={sellerShopName} />
//                                     </div>
//                                     <span className='text-sm font-medium truncate' style={{ color: sellerColorDark }}>
//                                         {sellerShopName}
//                                     </span>
//                                 </Link>
//                             ))}
//                         </div>
//                     </div>

//                     {/* Main chat area */}
//                     <div className='flex-1 min-w-0'>
//                         {currentFd ? (
//                             <div className='flex flex-col gap-2'>
//                                 {/* Message list */}
//                                 <div
//                                     className='h-[350px] w-full border-2 p-3 overflow-y-auto flex flex-col gap-3'
//                                     style={{
//                                         backgroundColor: sellerColorLight,
//                                         borderColor: sellerColorDark,
//                                         borderRadius: "18px 0px 0px 18px",
//                                     }}>
//                                     {fb_messages.map((m, i) => {
//                                         const isSellerMsg = currentFd?.fdId !== m.receiverId;
//                                         return (
//                                             <div
//                                                 ref={scrollRef}
//                                                 key={i}
//                                                 className={`flex gap-2 items-end ${isSellerMsg ? 'justify-start' : 'justify-end'}`}>
//                                                 {isSellerMsg && (
//                                                     <div className='flex flex-col items-center flex-shrink-0'>
//                                                         <img
//                                                             className='w-[32px] h-[32px] rounded-full object-cover border-2'
//                                                             src={sellerSellerImage}
//                                                             alt={sellerShopName}
//                                                             style={{ borderColor: sellerColorDark }}
//                                                         />
//                                                         <span className='text-[9px] font-semibold mt-0.5' 
//                                                             style={{ color: sellerColorDark }}>
//                                                             {sellerShopName.substring(0, 8)}
//                                                         </span>
//                                                     </div>
//                                                 )}
//                                                 {/*  bg-cyan-500 bg-purple-500 */}
//                                                 <div
//                                                     className={`px-3 py-2 rounded-2xl max-w-[75%] text-white text-sm leading-snug shadow-sm 
//                                                         border-2 border-red-700
//                                                         ${isSellerMsg ? 'rounded-bl-sm' : 'rounded-br-sm'
//                                                         }`}
//                                                     style={{
//                                                         // backgroundColor: isSellerMsg ? sellerPrimaryColor1 : sellerPrimaryColor1 + sellerColorSuffixMedium,
//                                                         // color: isSellerMsg ? 'white' : 'black',
//                                                         // borderColor: isSellerMsg ? sellerPrimaryColor1 : 'transparent'

//                                                         backgroundColor: isSellerMsg ? sellerColorDark : 'white',
//                                                         color: isSellerMsg ? 'white' : sellerColorDark,
//                                                         borderColor: isSellerMsg ? 'transparent' : sellerColorDark 
//                                                     }}>
//                                                     <p className='break-words text-[13px] font-semibold'>{m.message}</p>
//                                                     <p className='text-[11px] mt-0.5 opacity-70 text-right'>
//                                                         {Moment(m.updatedAt).format('M/DD/YY h:mm a')}
//                                                     </p>
//                                                 </div>

//                                                 {!isSellerMsg && (
//                                                     <div className='flex flex-col items-center flex-shrink-0'>
//                                                         <img
//                                                             className='w-[32px] h-[32px] rounded-full object-cover border-2'
//                                                             src={`${sellerFrontendURL}/images/user.png`}
//                                                             alt={customerName}
//                                                             style={{ borderColor: sellerColorDark }}
//                                                         />
//                                                         <span className='text-[10px] font-semibold mt-0.5' 
//                                                             style={{ color: sellerColorDark }}>
//                                                             {customerName?.substring(0, 8)}
//                                                         </span>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         );
//                                     })}
//                                     <div className={` ${fb_messages.length > 0 ? 'hidden' : ''}  
//                                         w-full flex justify-center items-center text-[26px] font-semibold gap-2 mt-24`}
//                                         style={{ color: sellerColorMedium }}>
//                                         <IoChatbubbleEllipsesOutline size={42}  />
//                                         Let's Start A Conversation
//                                     </div>
//                                 </div>
                                                
//                                 {/* Input bar */}
//                                 {isSellerSocketConnected && (
//                                     <div
//                                         className='flex items-end mt-0 pl-0.5 border-2 rounded-xl'
//                                         style={{ 
//                                             //borderColor: sellerColorDark, 
//                                             borderColor: canSend ? sellerColorDark : sellerColorMedium,
//                                             backgroundColor: sellerColorLight
//                                         }}>
//                                         <textarea
//                                             ref={textareaRef}
//                                             value={text}
//                                             onChange={e => setText(e.target.value)}
//                                             onKeyDown={handleKeyDown}
//                                             placeholder='Type a message… (Enter to send, Shift+Enter for new line)'
//                                             rows={1}
//                                             className='flex-1 resize-none outline-none bg-transparent text-[16px] leading-snug 
//                                             py-0.5 px-2 max-h-[100px] overflow-y-auto border-none border-black'
//                                             style={{ color: sellerColorDark }}
//                                         />
//                                         <button
//                                             onClick={send_message_to_seller_local} aria-label='Send message' disabled={!canSend}
//                                             className='flex-shrink-0 w-[42px] h-[26px] m-0 rounded-md flex items-center 
//                                                 justify-center text-white transition-opacity'
//                                             style={{
//                                                 // backgroundColor: sellerColorDark,
//                                                 backgroundColor: canSend ? sellerColorDark : sellerColorMedium,
//                                                 // opacity: canSend ? 1 : 0.35,
//                                                 cursor: canSend ? 'pointer' : 'not-allowed'
//                                             }}>
//                                             <IoSend className='text-[18px] sm:text-[26px]' />
//                                         </button>
//                                     </div>
//                                 )}
//                             </div>
//                         ) : (
//                             <div className='w-full py-10 flex flex-col justify-center items-center gap-3'>
//                                 <IoChatbubbleEllipsesOutline className='text-5xl' style={{ color: sellerColorMedium }} />
//                                 <span className='text-base font-semibold' style={{ color: sellerColorMedium }}>
//                                     One moment please…
//                                 </span>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Chat;




//my original code
// import React, { useEffect, useRef, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { Link, useParams } from 'react-router-dom'

// import { AiOutlineMessage, AiOutlinePlus } from 'react-icons/ai'
// import { GrEmoji } from 'react-icons/gr'
// import { IoSend } from 'react-icons/io5'
// import {FaList} from 'react-icons/fa'
// import { IoChatbubbleEllipsesOutline, IoChatbubbleEllipsesSharp } from "react-icons/io5";

// import { add_friend, messageClear, send_message_to_seller, updateMessage } from '../../store/reducers/chatReducer';
// import GetSellerConfig from '../GetSellerConfig';

// import toast from 'react-hot-toast';
// import Moment from 'moment/moment';

// import config from '../../config';
// import io from 'socket.io-client'

// //socket has to be last STR_BACKEND_URL
// ///const socket = io(localHostName)//backend
// const socket = io(config.STR_BACKEND_URL)
// const Chat = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL

//     const { userInfo } = useSelector(state => state.auth)
//     const { fb_messages, currentFd, my_friends, successMessage } = useSelector(state => state.chat)
    
//     const customerName = userInfo?.name
//     const { seller } = useSelector(state => state.seller)

//     const sellerChatOnline = seller?.isVisibleSiteChatOnline
    
//     const { 
//         sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
//         sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
//         sellerShopName, sellerSellerImage, sellerChatOfflineMessage, sellerBoolShowSiteChatOnline
//     } = GetSellerConfig();

//     const scrollRef = useRef()
//     const dispatch = useDispatch()
//     //const {sellerId} = useParams()
    
//     let {chatTopic} = useParams()

//     if (chatTopic === undefined) {
//             chatTopic = ''
//     } else {
//         chatTopic = chatTopic !== '' ? 'I Have A Question About ' + chatTopic : '' 
//     }   

//     const [text, setText] = useState(chatTopic) // useState('')
//     const [receiverMessage, setReceiverMessage] = useState('')
//     const [activeSeller, setActiveSeller] = useState([]) //lecture 412
//     const [show, setShow] = useState(false)
    
//     //console.log(sellerId)receiverId
//     //react call function every 10 seconds
//     // const myFunction = () => {
//     //     console.log('Function called!');
//     // if (customerId) {
//     //     //console.log(currentCustomer)
//     //     dispatch(get_customer_messages(customerId))
//     //fb_messages updated 
//     //updateMessage
//     // }
//     //};

//     // useEffect(() => {
//     //     const intervalId = setInterval(myFunction, 10000); // 10000 milliseconds = 10 seconds
//     //     // Clear the interval on component unmount
//     //     return () => clearInterval(intervalId);
//     //   }, []);

//     useEffect(() => {
//         //socket.emit('add_user', userInfo.id, userInfo) //shows green dot active customer on seller dashboard
//     },[])

//     useEffect(() => {
//         dispatch(add_friend({
//             sellerId: sellerId || "",
//             userId: userInfo.id
//         }))
//     },[sellerId])
    
//     const send_message_to_seller_local = () => {
//         //alert(text)
//         if (text) {
//            //toast.success(successMessage) 
//             dispatch(send_message_to_seller({
//                 userId: userInfo.id,
//                 text,
//                 sellerId,
//                 name: userInfo.name 
//             }))
//             setText('')
//             socket.emit('add_user', userInfo.id, userInfo) //sets active user
//             //alert(socket.id)
//             //console.log(socket)
//         }
//     }
    
//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter') {
//           send_message_to_seller_local()
//         }
//     };

//     useEffect(() => {
//         socket.on('seller_message', msg => {
//             //alert(msg.message)
//             setReceiverMessage(msg)
//             //alert('socket.id ' + socket.id) //works seller to customer
//             //alert(receiverMessage.message)
//         })
//         socket.on('activeSeller', (sellers) => {
//             setActiveSeller(sellers)
//         })
//         //console.log(activeSeller)
//     },[])

//     useEffect(() => {
//         if (successMessage) {
//             //console.log(fb_messages[fb_messages.length - 1])
//             socket.emit('send_customer_message', fb_messages[fb_messages.length - 1]) //works
//             //alert(socket.id)
//             dispatch(messageClear())
//         }
//     },[successMessage])

//     useEffect(() => {
//         //alert('chat sellerId: ' + sellerId)
//         if (receiverMessage) {
//             //alert(socket.id)
//             //alert('chat FE receiverMessage socket.id ' + socket.id)
//             //alert('receiverMessage', receiverMessage.message)
//             if (sellerId === receiverMessage.senderId && userInfo.id === receiverMessage.receiverId) {
//                 //customer is logged on
//                 toast.success(receiverMessage.senderName + "\n" + "Sent A Message")
//                 dispatch(updateMessage(receiverMessage))
//             } else {
//                 toast.success(receiverMessage.senderName + "\n" + "Sent A Message")
//                 dispatch(messageClear())
//             }
//         }
//     },[receiverMessage])

//     useEffect(() => {
//         scrollRef.current?.scrollIntoView({ behavior: 'smooth'})
//     },[fb_messages])

//     return (
//         <div className='bg-white p-3 border rounded-md '
//             style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//             <div className='text-2xl font-bold flex mb-2 ' style={{color:sellerPrimaryColor1}}>
//                 <IoChatbubbleEllipsesOutline className='mt-1 mr-1' />
//                Chat With {sellerShopName} - We Are {sellerChatOnline}
//             </div>
//             <div className={` ${sellerBoolShowSiteChatOnline ? 'hidden' : ''} text-md font-semibold flex flex-col mb-2`} 
//                 style={{color:sellerPrimaryColor1}}>
//                 {sellerChatOfflineMessage}
//             </div>
//             <div className='w-full flex'>
//                 <div className={`hidden w-[220px] mr-4 border rounded-lg md-lg:absolute bg-white md-lg:h-full -left-[350px] 
//                     ${show ? '-left-0' : '-left-[350px]'}`} 
//                     style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                     <div className='flex justify-center gap-3 items-center text-xl h-[50px]'
//                         style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                         <span><AiOutlineMessage /></span>
//                         <span>Messages</span>
//                     </div>
//                     <div className='w-full flex flex-col py-1 h-[194px] pr-3'
//                         style={{color:sellerPrimaryColor1}}>
//                         {
//                             my_friends.map((f,i) => 
//                                 <Link to={`/customerDashboard/chat/${f.fdId}`} key={i}  
//                                     className={`flex gap-2 justify-start items-center pl-2 py-[5px]`} >
//                                     <div className='w-[30px] h-[30px] rounded-full relative'>
//                                         {
//                                             activeSeller.some(c => c.sellerId === f.fdId ) && 
//                                                 <div className='w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0'></div> 
//                                             //<img className='rounded-full' src={f.image} alt="" />
//                                         } 
//                                         <img className='rounded-full' src={sellerSellerImage} alt="" />
//                                     </div>
//                                     <span className='text-[16px]'>{sellerShopName}</span>
//                                     {
//                                         //<span className='text-[14px]'>{f.name}</span>
//                                     }
//                                 </Link> 
//                             )
//                         }
//                     </div>
//                 </div>
//                 <div className='w-[calc(100%-220px)] md-lg:w-full'>
//                     {/*activeSeller  h-[400px] border border-black */}
//                     {
//                         currentFd ?
//                         <div className='w-full'>
//                             <div className='flex justify-between gap-3 items-center text-xl'
//                                 style={{color:sellerPrimaryColor1}}>
//                                 {
//                                 // <div className='flex gap-2'>
//                                 //     <div className='w-[30px] h-[30px] rounded-full relative'>
//                                 //         {
//                                 //         activeSeller.some(c => c.sellerId === currentFd.fdId) && 
//                                 //             <div className='w-[10px] h-[10px] rounded-full bg-green-500 absolute right-0 bottom-0'></div>
//                                 //         }
//                                 //         <img className='rounded-full' src={sellerImage} alt="" />
//                                 //         {/*<img className='rounded-full' src={currentFd.image} alt="" />*/}
//                                 //     </div>
//                                 //     <span>{sellerCompanyName} (We Are {sellerChatStatus})</span>
//                                 //     {/*<span>{currentFd.name}</span>*/}
//                                 // </div>
//                                 }
//                                 {
//                                 // <div onClick={()=> setShow(!show)} 
//                                 //     className='hidden w-[35px] h-[35px] md-lg:flex cursor-pointer rounded-sm 
//                                 //     justify-center items-center text-white'
//                                 //     style={{backgroundColor:sellerPrimaryColor1}}>
//                                 //     <FaList/>
//                                 // </div>

//                                     // className='pl-1 w-full outline-none 2xs:h-[56px] xs:h-[56px] sm:h-[56px]  
//                                     //         md:h-[28px] lg:h-[28px] xl:h-[28px] 2xl:h-[28px] 3xl:h-[28px] 4xl:h-[28px]' 

//                                 }
//                             </div>
//                             <div className='h-[350px] w-full border bg-slate-100 p-3 rounded-lg' 
//                                 style={{color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                 <div className='w-full h-full overflow-y-auto flex flex-col gap-3'>
//                                     {
//                                         fb_messages.map((m, i) => {
//                                             if (currentFd?.fdId !== m.receiverId) { //seller messages src={`${config.STR_FRONTEND_URL}/images/admin.png`}
//                                                 return(
//                                                     <div ref={scrollRef} key={i} className='w-full flex gap-2 justify-start items-center text-[14px]'>
//                                                         <div className='flex flex-col justify-center items-center md:px-3 py-2 max-w-full lg:max-w-[85%]'>
//                                                             <img className='[38px] h-[38px] max-w-[38px] border-2 rounded-full p-[2px]' 
//                                                             src={`${sellerSellerImage}`} alt="admin" style={{borderColor:sellerPrimaryColor1}} />
//                                                             <span className='text-[10px] font-semibold border-none border-black'>
//                                                                 {sellerShopName.substring(0, 6)}...
//                                                             </span>
//                                                         </div>
//                                                         <div className='p-2 bg-purple-500 text-white rounded-lg'>
//                                                             <span>{m.message}</span>
//                                                             <div className='text-sm'>
//                                                                 {Moment(m.updatedAt).format('M/DD/yyyy h:mm a')}
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 )
//                                             } else { 
//                                                 return(
//                                                     <div ref={scrollRef} key={i} className='w-full flex gap-2 justify-end items-center text-[14px]'>
//                                                         <div className='p-2 bg-cyan-500 text-white rounded-lg max-w-full lg:max-w-[85%]'  >
//                                                             <span>{m.message}</span>
//                                                             <div className='text-sm'>
//                                                                 {Moment(m.updatedAt).format('M/DD/yyyy h:mm a')}
//                                                             </div>
//                                                         </div>  
//                                                         <div  className='flex flex-col justify-center items-center'>
//                                                             <img className='[38px] h-[38px] border-2 rounded-full max-w-[38px] p-[2px]' 
//                                                                 src={`${sellerFrontendURL}/images/user.png`} alt="userpng" 
//                                                                 style={{borderColor:sellerPrimaryColor1}} />
//                                                             <div className='text-[10px] font-semibold'>
//                                                                 {customerName?.substring(0, 6)}...
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 )
//                                                 //p-2 bg-cyan-500 text-white rounded-lg

//                                             //  <div key={i} ref={scrollRef} className='w-full flex justify-end items-center'>
//                                             //     <div className='flex justify-start items-start gap-2 md:px-3 py-2 max-w-full lg:max-w-[85%]'>
//                                             //         <div className='flex justify-center items-start flex-col w-full bg-red-500 shadow-lg shadow-red-500/50 
//                                             //             text-white py-1 px-2 rounded-lg'>
//                                             //             <span>{m.message}</span>
//                                             //             <div className='text-sm'>
//                                             //                 {Moment(m.updatedAt).format('M/DD/yyyy h:mm a')}
//                                             //             </div>
//                                             //         </div>
//                                             //         <div>
//                                             //             <img className='w-[38px] h-[38px] border-2 border-white rounded-full max-w-[38px] p-[3px]' 
//                                             //                 src={userInfo?.sellerImage} alt="" />
//                                             //             <span className='text-[11px] text-white font-semibold'>Seller</span>
//                                             //         </div>
//                                             //     </div> 
//                                             // </div>


//                                             }
//                                         })
//                                     }
//                                     {
//                                         //     <div className='w-full flex gap-2 justify-start items-center text-[14px]'>
//                                         //     <img className='w-[30px] h-[30px]' src="http://localhost:3000/images/user.png" alt="" />
//                                         //     <div className='p-2 bg-purple-500 text-white rounded-md'>
//                                         //         <span>weewewewewewewe</span>
//                                         //     </div>
//                                         // </div>
//                                         //     <div  className='w-full flex gap-2 justify-end items-center text-[14px]'>
//                                         //     <img className='w-[30px] h-[30px] ' src="http://localhost:3000/images/user.png" alt="" />
//                                         //     <div className='p-2 bg-cyan-500 text-white rounded-md'>
//                                         //         <span>ewwwwwwwww</span>
//                                         //     </div>
//                                         // </div> 
//                                     }
//                                 </div>
//                             </div>
                            
//                             <div className={` ${sellerBoolShowSiteChatOnline ? '' :'hidden'} flex mt-2 p-0 w-full border-none rounded-lg`}
//                                 style={{backgroundColor:sellerSecondaryColor1, color:sellerPrimaryColor1, borderColor:sellerPrimaryColor1}}>
//                                 {/*flex justify-between items-center */}
//                                 {
//                                 // <div className='hidden w-[40px] h-[40px] border p-2 justify-center items-center rounded-full'>
//                                 //     <label className='hidden cursor-pointer' htmlFor=""><AiOutlinePlus /></label>
//                                 //     <input className='hidden' type="file" />
//                                 // </div>
//                                 }
                               
//                                 <div className={` border w-[calc(100%-90px)] rounded-full relative 2xs:h-[56px] xs:h-[56px] sm:h-[56px]  
//                                     md:h-[30px] lg:h-[30px] xl:h-[30px] 2xl:h-[30px] 3xl:h-[30px] 4xl:h-[30px]`}>
//                                     <textarea value={text} onChange={(e) => setText(e.target.value)} onKeyDown={handleKeyDown} 
//                                         type="text" placeholder='Type Chat Message' 
//                                         className={` pl-1 w-full outline-none 2xs:h-[56px] xs:h-[56px] sm:h-[56px]  
//                                             md:h-[24px] lg:h-[24px] xl:h-[24px] 2xl:h-[24px] 3xl:h-[24px] 4xl:h-[24px]`} />
//                                         { 
//                                         // ${sellerChatOnline === 'Offline' ? 'disabled:cursor-not-allowed disabled:opacity-50' : ''}
//                                         //from dash borad
//                                         // <input disabled={customerId ? false : true}  value={text} onChange={(e) => setText(e.target.value)}
//                                         //     type="text" placeholder={customerId ? 'Input Your Message' : 'Select Customer From The Left Side'}
//                                         //     className='w-full flex justify-between px-2 py-[5px] border border-slate-700 items-center  
//                                         //     focus:border-blue-500 rounded-md outline-none bg-transparent text-[#d0d2d6]'  />
                                            
//                                         // <button disabled={customerId ? false : true} 
//                                         //     className='shadow-lg bg-[#06b6d4] hover:shadow-cyan-500/50 text-semibold w-[75px] h-[35px] 
//                                         //     rounded-md text-white flex justify-center items-center'>
//                                         //     Send
//                                         // </button>
                                        
//                                         // <input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={handleKeyDown} 
//                                         // type="text" placeholder='input message' 
//                                         // className='2xs:hidden xs:hidden w-full rounded-lg outline-none p-2' />
                                    
//                                         // <div className='hidden text-2xl right-2 top-2 absolute cursor-auto'>
//                                         //     <span><GrEmoji /></span>
//                                         // </div>
//                                         //w-[20px] h-[20px] justify-center items-center
//                                         //p-2  rounded-full border-4
//                                     }
//                                 </div>
//                                 <div className='pl-2'>
//                                     <div onClick={send_message_to_seller_local}  className={`text-2xl cursor-pointer border`}>
//                                         <IoSend />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div> 
//                         : 
//                         <div  onClick={() => setShow(true)} 
//                             className='w-full h-[400px] flex justify-center items-center text-lg font-bold text-slate-600'>
//                             <span>One Moment Please ...</span>
//                         </div>
//                     }
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Chat;









